import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { isLocum: { type: Boolean, default: false } }
  static targets = [ 'userId', 'locumFields', 'locumInput' ]

  userChanged() {
    this.isLocumValue = this.locumSelected()
  }

  isLocumValueChanged() {
    this.locumInputTargets.forEach((input) => {
      if(this.isLocumValue) {
        input.removeAttribute('disabled')
      } else {
        input.setAttribute('disabled', true)
      }

      if(input.tomselect) {
        input.tomselect.sync()
        // sync seems to be not enough if disabled
        input.tomselect.enable()
        input.tomselect.unlock()
      }
    })

    if(this.isLocumValue) {
      this.locumFieldsTarget.classList.remove('d-none')
    } else {
      this.locumFieldsTarget.classList.add('d-none')
    }
  }

  locumSelected() {
    const select = this.userIdTarget
    return select.options[select.selectedIndex].getAttribute('data-locum') == 'true'
  }
}
